import { axiosInstance } from 'src/services/axiosInstance'
import { HEADER_SEARCH } from '../constants'

export const searchAssets = async (query: string, contract: string) => {
	const { data } = await axiosInstance.get(`${HEADER_SEARCH}?contract=${contract}&searchText=${query}`)

	return data
}
